module.exports = __webpack_public_path__ + "static/media/marcelgoogleplay.000a1b1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/marcelgoogleplay.jpg
// module id = 1572
// module chunks = 0